(function () {
    'use strict';

    angular
        .module('ccsTrApp')
        .factory('TabData', TabData);

    TabData.$inject = ['$rootScope', '$state'];

    function TabData($rootScope, $state) {

        var service = {
            initialiseTabs: initialiseTabs,
            addTabs: addTabs,
            checkParams: checkParams,
            buildParamObj: buildParamObj,
            ifDuplicate: ifDuplicate,
            findIndex: findIndex,
            stateAfterCloseTab: stateAfterCloseTab,
            updateParentTab: updateParentTab
        };

        return service;

        function initialiseTabs() {
            var initData = [
                {
                    heading: 'Dashboard',
                    route: 'home',
                    id: '',
                    param: {id: ''}
                }
            ];
            if ($state.current.name !== "home") {
                var currentId = '';
                if (undefined !== $state.params.id) {
                    currentId = $state.params.id;
                }
                var currentState = {
                    heading: $state.current.data.pageTitle,
                    route: $state.current.name,
                    id: currentId
                };
                initData.push(currentState);
            }
            return initData;
        }

        function ifDuplicate(tabData, data) {
            var found = false;
            for (var i = 0; i < tabData.length; i++) {
                if (( tabData[i].heading === data.heading ) && ( tabData[i].route === data.route )) {
                    found = true;
                    break;
                }
            }
            return found;
        }

        function addTabs(data) {
            var newTab = {};
            newTab.heading = data.heading;
            newTab.route = data.route;
            newTab.id = data.id;
            if (checkParams(data)) {
                newTab.param = buildParamObj(data);
            }
            return newTab;
        }

        function checkParams(data) {
            return typeof data.param !== "undefined";
        }

        function buildParamObj(data) {
            var params = {};
            var keys = Object.keys(data.param);
            for (var k in keys) {
                params[keys[k]] = data.param[keys[k]];
            }
            return params;
        }

        function findIndex(tabData, data) {
            var index = 0;
            for (var i = 0; i < tabData.length; i++) {
                if (( tabData[i].heading === data.heading ) && ( tabData[i].route === data.route )) {
                    index = i;
                    break;
                }
            }
            return index;
        }

        function stateAfterCloseTab(tabData, index) {
            var state = "home";
            var activeTabIndex = 0;
            var tabLength = tabData.length;
            if (( index > 1 ) && ( tabLength > 1 )) {
                activeTabIndex = ( index - 1 );
                state = tabData[activeTabIndex].route;
            }
            return {route: state, index: activeTabIndex};
        }

        function updateParentTab(data) {
            var newParentTab = {
                heading: '<i>' + data.title + '</i>',
                route: data.route,
                url: data.url
            };
            return newParentTab;
        }
    }
})();
